import { BrowserModule } from "@angular/platform-browser";
import { NgModule, APP_INITIALIZER, ErrorHandler } from "@angular/core";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DataTablesModule } from "angular-datatables";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { LicenceBandComponent } from "./pages/licence/licence-band/licence-band.component";
import { LicenceCountryComponent } from "./pages/licence/licence-country/licence-country.component";
import { LicenceCountryBandComponent } from "./pages/licence/licence-country-band/licence-country-band.component";
import { LicenceBandgroupComponent } from "./pages/licence/licence-bandgroup/licence-bandgroup.component";
import { AwardsComponent } from "./pages/awards/awards.component";
import { AwardsBandgroupComponent } from "./pages/awards/awards-bandgroup/awards-bandgroup.component";
import { AwardsBandComponent } from "./pages/awards/awards-band/awards-band.component";
import { AwardsCountryComponent } from "./pages/awards/awards-country/awards-country.component";
import { AwardsCountryBandComponent } from "./pages/awards/awards-country-band/awards-country-band.component";
import { AwardsDetailsComponent } from "./pages/awards/awards-details/awards-details.component";
import { TokenInterceptor } from "./shared/interceptor/token.interceptor";
import { CapitalizePipe } from "./shared/capitalize.pipe";
import { LicenceCountryBandgroupComponent } from "./pages/licence/licence-country-bandgroup/licence-country-bandgroup.component";
import { AwardsCountryBandgroupComponent } from "./pages/awards/awards-country-bandgroup/awards-country-bandgroup.component";
import { LicenceComponent } from "./pages/licence/licence.component";
import { Delete2FirstCharPipe } from "./shared/delete-2-first-char.pipe";
import { AuthInterceptor } from "./shared/interceptor/auth.interceptor";
import { FilterComponent } from "./filter/filter.component";
import { AboutComponent } from "./pages/about/about.component";
import { ErrorComponent } from "./pages/error/error.component";
import { UserService } from "./shared/user/user.service";
import { ForceTargetPipe } from "./shared/force-target.pipe";
import { FilterService } from "./filter/filter.service";
import * as Sentry from "@sentry/angular";
import { Router } from "@angular/router";
import { UpgradeComponent } from "./pages/upgrade/upgrade.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatTabsModule } from "@angular/material/tabs";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { UpcomingComponent } from "./pages/reports/upcoming/upcoming.component";
import {
  AuthConfig,
  OAuthModule,
  OAuthService,
} from "angular-oauth2-oidc";
import { authConfig } from "./auth.config";
import { filter } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { PreserveRegionParamsDirective } from "./preserve-region-params.directive";
import { OperatorsComponent } from "./pages/reports/operators/operators.component";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

// export function initUser(userService: UserService) {
//     return () => userService.loadUser();
// }

// export function initializeOAuthLogin(userService: UserService) {
//   return () => userService.loginSso();
// }

// export function initFilterData(filterService: FilterService) {
//     return () => filterService.loadFilters();
// }

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LicenceBandComponent,
    LicenceCountryComponent,
    LicenceCountryBandComponent,
    LicenceBandgroupComponent,
    AwardsComponent,
    AwardsBandgroupComponent,
    AwardsBandComponent,
    AwardsCountryComponent,
    AwardsCountryBandComponent,
    AwardsDetailsComponent,
    CapitalizePipe,
    LicenceCountryBandgroupComponent,
    AwardsCountryBandgroupComponent,
    LicenceComponent,
    Delete2FirstCharPipe,
    FilterComponent,
    AboutComponent,
    ErrorComponent,
    ForceTargetPipe,
    UpgradeComponent,
    UpcomingComponent,
    OperatorsComponent,
    PreserveRegionParamsDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    OAuthModule.forRoot({
      resourceServer: {
        sendAccessToken: true,
      },
    }),
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,

    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: AuthConfig,
      useValue: authConfig,
    },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initializeOAuthLogin,
    //   deps: [UserService],
    //   multi: true,
    // },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initUser,
    //   deps: [UserService,OAuthService],
    //   multi: true
    // },
    //{
    //   provide: APP_INITIALIZER,
    //   useFactory: initFilterData,
    //   deps: [FilterService],
    //   multi: true
    // },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
